import { descriptorsFactory } from '../../utils/filters';

export const hasDecorationDescriptors = descriptorsFactory({
  name: 'hasDecoration',
  clear: [],
})(
  {
    form: [{ key: 'decorations_list', value: ['without'], type: 'terms' }],
    label: 'Без отделки',
    state: 'without',
  },
  {
    form: [{ key: 'decorations_list', value: ['rough'], type: 'terms' }],
    label: 'Черновая',
    state: 'rough',
  },
  {
    form: [{ key: 'decorations_list', value: ['preFine'], type: 'terms' }],
    label: 'Предчистовая',
    state: 'preFine',
  },
  {
    form: [{ key: 'decorations_list', value: ['fine'], type: 'terms' }],
    label: 'Чистовая',
    state: 'fine',
  },
  {
    form: [{ key: 'decorations_list', value: ['fineWithFurniture'], type: 'terms' }],
    label: 'Чистовая с мебелью',
    state: 'fineWithFurniture',
  },
);
